import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface PasswordStrengthRules {
    minLength:  boolean;
    hasUpper:   boolean;
    hasLower:   boolean;
    hasNumber:  boolean;
    hasSpecial: boolean;
}

@Component({
    selector: 'app-password-strength',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './password-strength.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordStrengthComponent {
    password = input.required<string>();

    readonly rules = computed<PasswordStrengthRules>(() => {
        const p = this.password();
        return {
            minLength:  p.length >= 8,
            hasUpper:   /[A-Z]/.test(p),
            hasLower:   /[a-z]/.test(p),
            hasNumber:  /\d/.test(p),
            hasSpecial: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(p),
        };
    });

    readonly score = computed(() =>
        Object.values(this.rules()).filter(Boolean).length,
    );

    readonly meta = computed(() => {
        const s = this.score();
        if (s <= 1) return { label: 'Weak',        cls: 'weak' };
        if (s <= 2) return { label: 'Fair',         cls: 'fair' };
        if (s <= 3) return { label: 'Good',         cls: 'good' };
        if (s <= 4) return { label: 'Strong',       cls: 'strong' };
        return          { label: 'Very strong',  cls: 'very-strong' };
    });
}
